<template>
  <div class="title-container">
    <div class="title-content">
      <springText class="item-title" text="Purchase Character NFTs"></springText>
    </div>
    <fadeInAnimation>
      <div class="text-list">
        <div class="text-item">
          <div class="title">
            Visit NFT Marketplaces
          </div>
          <div class="sub-title">
            Go to NFT marketplaces like OpenSea, OKX, etc., to purchase character NFTs. If you purchase Blueprints
            instead
            of Character directly, after step 2, you need to convert your blueprint into character on Matr1x Website.
          </div>
          <div class="sub-title alink-sub">
            <div class="icon-wrap">
              <img src="@/assets/images/playDetails/marketplace/tradingLink.png" alt="">
            </div>
            Trading Link: <a target="_blank"
              href="https://www.okx.com/web3/marketplace/nft/collection/polygon/matr1x-fire-character">https://www.okx.com/web3/marketplace/nft/collection/polygon/matr1x-fire-character</a>
            <i class="el-icon-caret-right"></i>
          </div>
        </div>
        <div class="text-item">
          <div class="title">
            Transfer Purchased NFTs to Your MATR1X Account
          </div>
          <div class="sub-title">
            Log in to <a target="_blank"
              href="https://matr1x.io/asset?source=game">https://matr1x.io/asset?source=game</a> and deposit the
            character NFTs into your MATR1X platform account.
          </div>
        </div>
        <div class="text-item">
          <div class="title">
            Use Character NFT
          </div>
          <div class="sub-title">
            Log in to the game, go to the "Characters" page, and select your character NFT to participate in mining.
          </div>
        </div>
      </div>
    </fadeInAnimation>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
import springText from "@/views/components/springText";
import fadeInAnimation from "@/views/components/fadeInAnimation";

export default {
  mixins: [responsiveMixin],
  components: { springText, fadeInAnimation },
  data() {
    return {};
  },
  mounted() { },
  methods: {},
  watch: {

  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>